import React, {useState} from 'react'
import SearchInputToolbar from '../../SearchInputToolbar';
import SelectExportType from '../../SelectExportType/SelectExportType';
import { ToolbarProps } from '../../../../pages/get-quote/models';
import { TextField, MenuItem, Tooltip } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useStyles } from '../../FreightInfo/FreightInformation/FreightInformationStyles';

import clsx from 'clsx'
import ClearIcon from '@mui/icons-material/Clear';
import { stylesMUIInput } from '../../../stylesMUIInput';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../../setup';
import { UserModel } from '../../../../modules/auth/models/UserModel';

const Toolbar = ({tableFor, searchTable, handleSearch, rateTypeSelected, setRateTypeSelected, rateTypes, columns, dataColumns, cancelCalls, linearProgress, ratesStopped, setRatesStopped}: ToolbarProps) => {
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const [buttonColor, setButtonColor] = useState('btn-danger')
    const classes = useStyles({props: {}})
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }

    return (
        <div className="row d-flex align-items-center mt-6">
            <div className="col-4">
                <SearchInputToolbar className="w-md-50 w-sm-75" searchTable={searchTable} handleSearch={handleSearch}/>
            </div>
            <div className="col-4 d-flex justify-content-center">
                <Tooltip title={linearProgress >= 100 || ratesStopped ? "" : "Stop Get Rates"}>
                    <button
                        style={{
                            cursor: linearProgress >= 100 || ratesStopped ? 'auto' : 'pointer',
                            opacity: linearProgress >= 100 || ratesStopped ? '0' : '1',
                            transition: (linearProgress >= 100 && "opacity 0.5s ease-in") || (ratesStopped && "opacity 2.5s ease-in"),
                        }}
                        className={`w-100 w-md-50 w-xl-25 btn ${buttonColor} ${ratesStopped ? 'disabled' : ''} d-flex justify-content-center align-items-center`}
                        onClick={() => {
                            cancelCalls()
                            setRatesStopped(true)
                            setButtonColor('btn-success')
                            setTimeout(() => {
                                setButtonColor('btn-danger')
                            }, 2550);
                        }}
                    >
                        {ratesStopped ? 'Stopped!' : <><ClearIcon fontSize="small" className="me-1"/>Stop</>}
                    </button>
                </Tooltip>                    
            </div>
            <div className="col-4 d-flex justify-content-end">
                <TextField
                    select
                    label=" "
                    value={rateTypeSelected}
                    onChange={(e) => {
                        setRateTypeSelected(e.target.value)
                    }}
                    className={clsx(classes.selectMUI, 'w-md-50 w-sm-75 me-3')}
                    InputProps={{
                        style: stylesMUIInput(fontSize),
                    }}
                    SelectProps={{
                        IconComponent: KeyboardArrowDownIcon,
                        MenuProps: menuProps
                    }}
                    InputLabelProps={{shrink: false}}
                >
                    <MenuItem value='ALL RATES'>All Rates</MenuItem>
                    {
                        rateTypes.sort((a, b) => a.value?.localeCompare(b.value)).map((rateType, index) => (
                            <MenuItem key={index} value={rateType.value}>{rateType.name}</MenuItem>
                        ))
                    }
                </TextField>
                {
                    user?.allowRateExport ?
                        <SelectExportType
                            fileName='Rates'
                            columns={columns}
                            dataColumns={dataColumns?.sort((a, b) => parseFloat(a.total) - parseFloat(b.total))}
                        />
                    : null
                }
            </div>
        </div>
    )
}

export default Toolbar